import { Theme } from '@mui/material/styles'

const useStyles = {
  protectMobileLink: {
    alignItems: 'center',
  },
  qrContainer: (theme: Theme) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.mediumBorderRadius,
  }),
}
export default useStyles
